import { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext({
  isDark: false,
  toggleTheme: () => {},
  setTheme: (theme) => {}
});

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  const [isDark, setIsDark] = useState(() => {
    // Check localStorage on init - default to FALSE (light mode)
    if (typeof window !== 'undefined') {
      const stored = localStorage.getItem('veyronix-dark-mode');
      if (stored !== null) {
        return stored === 'true';
      }
      // Default to light mode, ignore system preference
      return false;
    }
    return false;
  });

  useEffect(() => {
    // Apply theme to document
    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
    // Persist to localStorage
    localStorage.setItem('veyronix-dark-mode', isDark.toString());
  }, [isDark]);

  // Listen for storage events (sync across tabs)
  useEffect(() => {
    const handleStorage = (e) => {
      if (e.key === 'veyronix-dark-mode') {
        setIsDark(e.newValue === 'true');
      }
    };
    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);

  // Listen for system theme changes - DISABLED to force light mode by default
  // useEffect(() => {
  //   const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
  //   const handleChange = (e) => {
  //     // Only auto-switch if user hasn't set a preference
  //     const stored = localStorage.getItem('veyronix-dark-mode');
  //     if (stored === null) {
  //       setIsDark(e.matches);
  //     }
  //   };
  //   mediaQuery.addEventListener('change', handleChange);
  //   return () => mediaQuery.removeEventListener('change', handleChange);
  // }, []);

  const toggleTheme = () => setIsDark(prev => !prev);
  const setTheme = (theme) => setIsDark(theme === 'dark');

  return (
    <ThemeContext.Provider value={{ isDark, toggleTheme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeContext;
